export default async function markAsReadLeadNotification({ state }, { leadStatus }) {
  const leadsUpdated = state.get(['apartmentLocator', 'leadsUpdated']);

  Object.keys(leadsUpdated).forEach((leadRenterUserId) => {
    const { fromLeadStatus, toLeadStatus } = leadsUpdated[leadRenterUserId];

    if (fromLeadStatus === leadStatus) {
      state.unset(['apartmentLocator', 'leadsUpdated', leadRenterUserId, 'fromLeadStatus']);
    }

    if (toLeadStatus === leadStatus) {
      state.unset(['apartmentLocator', 'leadsUpdated', leadRenterUserId, 'toLeadStatus']);
    }
  });

  state.commit();
}
